import React from 'react';
import { Emoji } from './Emoji';
export function Footer() {
  return <footer className="w-full bg-forest-900 py-14" data-id="element-87" data-mp="3gf93arl2hy6u">
      <div className="mx-auto max-w-[680px] px-5 text-center sm:px-8" data-id="element-88" data-mp="3gg0za3iktxxn">
        <span className="inline-flex items-center gap-2 font-display text-base font-extrabold uppercase tracking-[0.24em] text-cream" data-id="element-89" data-mp="32oe09vx92bb6">
          <Emoji symbol="🌿" data-id="element-90" data-mp="36pz9n7aks7gm" />
          Close The Gap<span className="text-lime-400" data-id="element-91" data-mp="3ufa4671c15mb">™</span>
        </span>
        <p className="mx-auto mt-4 max-w-md text-[15px] leading-relaxed text-cream/70" data-id="element-92" data-mp="3uftlblj5rpza">
          El sistema de alimentación N°1 para argentinos que quieren comer bien
          sin perder el tiempo. Porque comer bien no debería costarte todos los
          domingos del año.
        </p>

        <ul className="mt-8 flex flex-col items-center gap-3" data-id="element-93" data-mp="3qbvojhhb2r9e">
          <li data-id="element-94" data-mp="29yxehh44xsnx">
            <a href="mailto:closethegap14@gmail.com" className="inline-flex items-center gap-2 text-sm text-cream/80 transition-colors duration-150 ease-out hover:text-lime-400" data-id="element-95" data-mp="29y5frxf8retf">
              <Emoji symbol="📧" data-id="element-96" data-mp="3la272nvdqrs2" />
              closethegap14@gmail.com
            </a>
          </li>
          <li data-id="element-97" data-mp="3gca859wbi5ed">
            <a href="https://instagram.com/closethegap14" className="inline-flex items-center gap-2 text-sm text-cream/80 transition-colors duration-150 ease-out hover:text-lime-400" data-id="element-98" data-mp="3gcjw6rxsy2hf">
              <Emoji symbol="📲" data-id="element-99" data-mp="82qt3uy8hxus" />
              @closethegap14
            </a>
          </li>
          <li data-id="element-100" data-mp="3474tnw649z9">
            <a href="https://www.recursoclosethegap.shop" className="inline-flex items-center gap-2 text-sm text-cream/80 transition-colors duration-150 ease-out hover:text-lime-400" data-id="element-101" data-mp="34gxjj8lkv8n">
              <Emoji symbol="🌐" data-id="element-102" data-mp="cv1qaq1lb5jn" />
              www.recursoclosethegap.shop
            </a>
          </li>
        </ul>

        <div className="mt-10 border-t border-cream/10 pt-6" data-id="element-103" data-mp="qtrne5oet580">
          <p className="inline-flex flex-wrap items-center justify-center gap-2 font-display text-sm font-bold text-lime-400" data-id="element-104" data-mp="mspqhvhyt597">
            “Tu heladera llena el lunes empieza el domingo a las 10 de la
            mañana.”
            <Emoji symbol="🌿" data-id="element-105" data-mp="yupkg74up2f3" />
          </p>
          <p className="mt-3 text-xs text-cream/45" data-id="element-106" data-mp="13tajw4ca3i2h">
            © Close The Gap™ 2025 — Todos los derechos reservados. Prohibida la
            reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}